var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-content"},[_c('div',{staticClass:"title-box"},[_c('span',{staticClass:"home-title"},[_vm._v(_vm._s(_vm.title))])]),_c('image-list',{attrs:{"list":_vm.list},on:{"preview":_vm.preview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }